<ng-container>
  @if (root && item.visible !== false) {
    <div class="layout-menuitem-root-text">
      {{ item.label }}
      @if (item.badge) {
        @if (item.badge.toLowerCase() === "test") {
          <i
            class="fa fa-flask ml-1"
            style="color: orange"
            title="Test"
            aria-hidden="true"
          ></i>
        } @else if (item.badge.toLowerCase() === "experimental") {
          <i
            class="fa fa-flask ml-1"
            style="color: dodgerblue"
            title="Experimental"
            aria-hidden="true"
          ></i>
        } @else {
          <p-badge
            [value]="item.badge!"
            [severity]="item.badge === 'Test' ? 'warning' : 'info'"
          />
        }
      }
    </div>
  }
  @if ((!item.routerLink || item.items) && item.visible !== false) {
    <a
      [attr.href]="item.url"
      (click)="itemClick($event)"
      [attr.target]="item.target"
      tabindex="0"
      pRipple
    >
      <i
        class="layout-menuitem-icon"
        [ngClass]="item.icon"
      ></i>
      <span class="layout-menuitem-text">{{ item.label }}</span>
      @if (item.items) {
        <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
      }
    </a>
  }
  @if (item.routerLink && !item.items && item.visible !== false) {
    <a
      (click)="itemClick($event)"
      [routerLink]="item.routerLink"
      routerLinkActive="active-route"
      [routerLinkActiveOptions]="
        item.routerLinkActiveOptions || {
          paths: 'exact',
          queryParams: 'ignored',
          matrixParams: 'ignored',
          fragment: 'ignored',
        }
      "
      [fragment]="item.fragment"
      [queryParamsHandling]="item.queryParamsHandling"
      [preserveFragment]="item.preserveFragment"
      [skipLocationChange]="item.skipLocationChange"
      [replaceUrl]="item.replaceUrl"
      [state]="item.state"
      [queryParams]="item.queryParams"
      [attr.target]="item.target"
      tabindex="0"
      pRipple
    >
      <i
        class="layout-menuitem-icon"
        [ngClass]="item.icon"
      ></i>
      <span class="layout-menuitem-text">{{ item.label }}</span>
      @if (item.badge) {
        @if (item.badge.toLowerCase() === "test") {
          <i
            class="fa fa-flask ml-1"
            style="color: orange"
            title="Test"
            aria-hidden="true"
          ></i>
        } @else if (item.badge.toLowerCase() === "experimental") {
          <i
            class="fa fa-flask ml-1"
            style="color: dodgerblue"
            title="Experimental"
            aria-hidden="true"
          ></i>
        } @else {
          <p-badge
            class="mb-4"
            [value]="item.badge!"
            [severity]="item.badge === 'Test' ? 'warning' : 'info'"
          />
        }
      }
    </a>
  }

  @if (item.items && item.visible !== false) {
    <ul [@children]="submenuAnimation">
      @for (child of item.items; track child; let i = $index) {
        <app-menuitem
          [item]="child"
          [index]="i"
          [parentKey]="key"
        />
      }
    </ul>
  }
</ng-container>
